var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import PlayerEventBus from "@/EventBuses/ThePlayerEventBus";
import HTTP from "@/http";
var AppPlayer = (function (_super) {
    __extends(AppPlayer, _super);
    function AppPlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.player = _this.$store.state.player;
        return _this;
    }
    Object.defineProperty(AppPlayer.prototype, "audioElement", {
        get: function () {
            return this.$refs["audio"];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppPlayer.prototype, "src", {
        get: function () {
            if (!this.$store.getters.audio)
                return null;
            if (this.$store.getters.audio.previewSource.provider !== "meyouseek")
                return null;
            return "https://myouseek.com/audio/" + this.$store.getters.audio.previewSource.provider_id + ".mp3";
        },
        enumerable: true,
        configurable: true
    });
    AppPlayer.prototype.calculateBuffered = function () {
        var audioElement = this.audioElement;
        var buffered = 0;
        if (audioElement.buffered.length) {
            var x = 0;
            while (x < audioElement.buffered.length && audioElement.buffered.start(x) < audioElement.currentTime) {
                ++x;
            }
            if (x < 1)
                x = 1;
            buffered = audioElement.buffered.end(x - 1);
        }
        return buffered;
    };
    AppPlayer.prototype.mounted = function () {
        var _this = this;
        PlayerEventBus.$on("seekTo", function (time) {
            if (_this.$store.getters.audio.provider !== "meyouseek")
                return;
            _this.audioElement.currentTime = time;
        });
        this.audioElement.addEventListener("durationchange", function (e) {
            _this.$store.dispatch("setDuration", _this.audioElement.duration);
        });
        this.audioElement.addEventListener("timeupdate", function (e) {
            _this.$store.dispatch("setTime", _this.audioElement.currentTime);
            _this.$store.dispatch("setBuffered", _this.calculateBuffered());
        });
    };
    AppPlayer.prototype.onSrcChange = function (newSrc) {
        if (!newSrc)
            this.audioElement.pause();
        this.audioElement.load();
    };
    AppPlayer.prototype.onStateChange = function (newState, oldState) {
        var _this = this;
        if (newState === oldState)
            return;
        if (!this.src)
            return;
        if (newState === 1) {
            if (oldState === 0) {
                this.audioElement.currentTime = 0;
            }
            setTimeout(function () {
                _this.audioElement.play();
            });
        }
        else if (newState === 0) {
            this.audioElement.pause();
        }
        else if (newState === 2) {
            this.audioElement.pause();
        }
    };
    AppPlayer.prototype.onAudioChange = function (id) {
        if (!this.$store.state.user)
            return;
        HTTP.post("/views", { audio_id: id })
            .then(function (response) {
        })
            .catch(function (response) {
        });
    };
    __decorate([
        Watch("src"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AppPlayer.prototype, "onSrcChange", null);
    __decorate([
        Watch("player.state"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], AppPlayer.prototype, "onStateChange", null);
    __decorate([
        Watch("$store.getters.audio.id"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AppPlayer.prototype, "onAudioChange", null);
    AppPlayer = __decorate([
        Component
    ], AppPlayer);
    return AppPlayer;
}(Vue));
export default AppPlayer;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ThePlayer/AppPlayer.vue
// module id = 266
// module chunks = 0